import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import ReusableTable from '../../components/ReusableTable';
import ComentarioButton from '../../components/ComentarioButton';
import { formatearBogota } from '../../utils/fecha';
import CalificarTareaButton from '../../components/CalificarTareaButton';
import EditarCalificacionButton from '../../components/EditarCalificacionButton';
import { getTareasPorUsuario } from '../../services/tareasService';
import { jwtDecode } from 'jwt-decode';
import '../HomePage.css'; // Reutilizando estilos

// Función para verificar si el usuario es administrador
const esAdmin = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.rolId === '1';
  } catch (error) {
    console.error("Error decodificando el token:", error);
    return false;
  }
};

// Función para verificar si el usuario es de soporte técnico
const esSoporteTecnico = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.rolId === '3';
  } catch (error) {
    console.error("Error decodificando el token:", error);
    return false;
  }
};

const getUserId = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.userId;
    } catch (error) {
      console.error("Error decodificando el token:", error);
      return null;
    }
  };

const VerTareasPage = () => {
  const navigate = useNavigate();
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTareas = async () => {
      const userId = getUserId();
      if (!userId) {
        setError('No se pudo obtener el ID del usuario. Por favor, inicie sesión de nuevo.');
        setLoading(false);
        return;
      }

      const response = await getTareasPorUsuario(userId);
      if (response.success) {
        console.log('Datos recibidos:', response.data); // Log para verificar los datos
        const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
        setTareas(tareasOrdenadas);
      } else {
        setError(response.message);
      }
      setLoading(false);
    };

    fetchTareas();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };

  const links = [
    { to: '/home', label: 'Home' },
    { to: '/crear-tarea', label: 'Crear Tarea' },
    { to: '/tareas', label: 'Ver Tarea' },
    { to: '/cambiar-contrasena', label: 'Cambiar Contraseña' },
  ];

  if (esAdmin()) {
    links.push({ to: '/admin', label: 'Admin Panel' });
  }

  // Si el usuario es de soporte técnico, añade el enlace de soporte
  if (esSoporteTecnico()) {
    links.push({ to: '/soporte', label: 'Soporte' });
  }

  const columns = [
    { key: 'idTarea', label: 'ID Tarea' },
    { key: 'observaciones', label: 'Observaciones' },
    {
      key: 'estado',
      label: 'Estado',
      formatter: (estado) => estado || ''
    },
    { key: 'areaNombre', label: 'Area' },
    { key: 'sedeNombre', label: 'Sede' },
    { key: 'servicioNombre', label: 'Servicio' },
    { key: 'cargoUsuarioCliente', label: 'Cargo' },
    { key: 'urlEvidencia', label: 'Evidencia', formatter: (url) => url ? (<a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>Ir a evidencia</a>) : '' },
    {
      key: 'calificacion',
      label: 'Calificación',
      formatter: (calificacion) => calificacion === null ? 'No se ha calificado' : calificacion
    },
    {
      key: 'fechaCreacion',
      label: 'Fecha Creación',
      formatter: (date) => formatearBogota(date)
    },
    {
      key: 'acciones',
      label: 'Acciones',
      formatter: (value, row) => {
        if (!row) {
          console.warn('Row es undefined');
          return null;
        }
        return (
          <>
            <ComentarioButton tareaId={row.idTarea} />
            {row.estado === 'Finalizado' && <CalificarTareaButton tareaId={row.idTarea} />}
            {row.calificacion !== null && <EditarCalificacionButton tarea={row} />}
          </>
        );
      }
    }
  ];

  return (
    <div className="home-container">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="home-content">
        <h1>Mis Tareas</h1>
        {loading && <p>Cargando tareas...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {!loading && !error && tareas.length > 0 && (
          <ReusableTable 
            data={tareas} 
            columns={columns}
            keyField="idTarea"
          />
        )}
        {!loading && !error && tareas.length === 0 && (
          <p>No hay tareas disponibles</p>
        )}
      </main>
    </div>
  );
};

export default VerTareasPage; 